import React from 'react';
import PropTypes from 'prop-types';

const formatThumbnailUrl = url => (
  (url.indexOf('1024px') !== -1) ? url.replace(/1024px/, '360px') : url
);

const MediaGalleryImage = ({ image, handleMediaClick }) => (
  <div id={`image-${image.id}`} data-props={`Image,${image.productLineName},${image.colorRange},${image.designStyle},${image.roomType}`} data-description={image.description} data-product-url={image.productLineUrl} data-image-url={image.imageUrl}>
    <button type="button" className="gallery-modal-toggle" aria-expanded={image.active} aria-controls={`modal-${image.id}`} onClick={() => handleMediaClick(image)}>
      <img className="lazy" data-src={formatThumbnailUrl(image.imageUrl)} alt={image.description} />
      <div className="loader-placeholder" aria-hidden="true">
        <svg id="loading" className="loading" data-name="loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
          <title>Loading</title>
          <path className="loading-path" d="M250,149A100,100,0,1,0,150,250c1.68,0,3.34-.06,5-.14V212.29c-1.65.14-3.32.21-5,.21A62.5,62.5,0,1,1,212.47,149H200l30,30,30-30Z" />
        </svg>
      </div>
    </button>
  </div>
);

MediaGalleryImage.propTypes = {
  handleMediaClick: PropTypes.func.isRequired,
  image: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    active: PropTypes.bool,
    productLineId: PropTypes.string,
    productLineName: PropTypes.string,
    productLineUrl: PropTypes.string,
    colorRange: PropTypes.string,
    designStyle: PropTypes.string,
    roomType: PropTypes.string,
  }),
};

export default MediaGalleryImage;
